var XPortal = XPortal || {};
XPortal.Redusers = XPortal.Redusers || {};
XPortal.Redusers = (function () {
    const self =
    {
        debug: false,
        _multipleValueSeparator: "_#_",
        ACTIONS: {
            VALIDATION_RESULT: 'VALIDATION_RESULT',
            SAVE_START: 'SAVE_START',
            SAVE_END: 'SAVE_END',
            SAVE_CANCEL: 'SAVE_CANCEL',
            NOTHING_SAVE: 'NOTHING_SAVE',
            ITEM_SAVE_SUCCESS: "ITEM_SAVE_SUCCESS",
            ITEM_SAVE_FAIL: "ITEM_SAVE_FAIL",
            EDIT_FORM_INITIALIZED: "EDIT_FORM_INITIALIZED",
            GRID_INITIALIZE: "GRID_INITIALIZE",
            GRID_INITIALIZED: "GRID_INITIALIZED",
            GRID_DATALOADED: "GRID_DATALOADED",
            EDITOR_LOADED: "EDITOR_LOADED",
            BIND_ENTITY: "BIND_ENTITY",
            EDIT_FIELD: "EDIT_FIELD",
            EDIT_DISPLAYFIELD: "EDIT_DISPLAYFIELD",
            END_EDIT: "END_EDIT",
            NOTIFY_EDITED: "FIELD_UPDATED_TO",
            DELETED_ENTITY: "DELETED_ENTITY",
            LOADED_ENTITY: "LOADED_ENTITY",
            ADD_MESSAGES: "ADD_MESSAGES",
            SERVER_MESSAGES: "SERVER_MESSAGES",
        }
    };
    const handlers = {};

    self.getModel = function (state, action) {
        var modelName = action.modelName;
        state.pageModels = state.pageModels || {};
        return state.pageModels[modelName] = state.pageModels[modelName] || {};
    };
    var getStackTrace = function () {
        var obj = {};
        Error.captureStackTrace(obj, getStackTrace);
        return obj.stack;
    };
    self.onDebuging = function (state, action, message, ...args) {
        if (!self.debug) return;
        self.counti = self.counti ? self.counti + 1 : 1;
        if (console && console.log) {
            var m = console.log;// : console.error;
            try {
                m("" + self.counti + ". type:" + action.type + " >" + message, {
                    s: Object.assign({}, state), a: Object.assign({}, action), arg: JSON.stringify(args), t: getStackTrace()
                });
            } catch (e) {
                m("" + self.counti + ". type:" + action.type + " >" + message);
            }
        }
    };
    /* --event processors--*/
    function onEditFormInitialized(state, action) {
        self.onDebuging(state, action, "", action.formParameters);
        return Object.assign({}, state, { editParameters: action.formParameters });
    }

    function onGridInitializing(state, action) {
        var newModel = {
            GridModel: action.modelValue,
            model: action.additionalModel
        };
        var modelName = action.model;
        self.onDebuging(state, action, modelName, action.additionalModel);
        state.pageModels = state.pageModels || {};
        state.pageModels[modelName] = state.pageModels[modelName] || {};
        Object.assign(state.pageModels[modelName], newModel);
        return Object.assign(state, { pageModels: state.pageModels });
    }

    function onGridInitialized(state, action) {
        return state;
    }

    function onEditorLoaded(state, action) {
        return state;
    }

    function onEntityBinding(state, action) {
        state.pageModels = state.pageModels || {};
        var currentModel = state.pageModels[action.modelName] || { model: {} };

        var newParams = [{ entity: action.entity }];
        if (action.model) newParams.push({ model: Object.assign(currentModel.model, action.model) });

        var currentModelParams = action.model ? action.model : currentModel.model;
        if (currentModelParams) {
            action.entity.NodeId = currentModelParams.NodeId;
            action.entity.EntityAlias = currentModelParams.Alias;
        }
        currentModel = Object.assign(currentModel, ...newParams);
        state.pageModels[action.modelName] = currentModel;
        self.onDebuging(state, action, action.modelName, action.entity);
        return Object.assign({}, state, { editParameters: state.editParameters, pageModels: state.pageModels });
    }

    function onEntityBinded(state, action) {
        return Object.assign({}, state, { WasValidated: false, LastRefresh: new Date() });
    }

    function onFieldEditing(state, action) {
        self.onDebuging(state, action, action.modelName, action.model);
        var afname = action.field.field;
        var afdata = action.field.data != null ? String(action.field.data) : null;
        if (!state.pageModels.hasOwnProperty(action.model))
            return state;
        var model = state.pageModels[action.model];
        var isNeedToRefreshGridCell = action.entity && action.entity.uid !== model.entity.uid;
        var entity = action.entity ? action.entity : model.entity;
        itemsToSave = model.itemsToSave;

        if (!action.field || !action.field.field) {
            if (console) console.log("Something wrong came to EDIT_FIELD");
            return state;
        }
        //if (entity.hasOwnProperty(action.field.field)) {
        var fieldObjList = entity.Fields.filter(f => f.Name.toLowerCase() === afname);
        var fieldObj = null;
        if (fieldObjList.length < 1) {
            entity.Fields.push({ Name: afname, Type: action.field.ftype });
            fieldObjList = entity.Fields.filter(f => f.Name.toLowerCase() === afname);
        }
        if (fieldObjList.length !== 1) //remove multi-fields
        {
            entity.Fields = entity.Fields.filter(f => f.Name.toLowerCase() !== afname);
            entity.Fields.push(fieldObjList[0]);
            fieldObjList = entity.Fields.filter(f => f.Name.toLowerCase() === afname);
        }
        fieldObj = fieldObjList[0];

        if (fieldObj && compareFieldsVal(fieldObj, afdata) || (stringifyAndNotEquals(entity[afname], afdata))) {
            if (state.editParameters) //update is changed
                state.editParameters.IsChanged = true;
            fieldObj.StringValue = afdata;
            fieldObj.IsChanged = true;

            if (entity._events && entity.set) { //grid observable 
                var valueToSet = action.field.data;
                if (fieldObj.Type && fieldObj.Type.toLowerCase() === "boolean")
                    valueToSet = action.field.data === "1" ? true : false;
                if (console) console.log(afname + " set from: " + entity[afname] + " to: " + valueToSet + " model:" + action.model);
                entity.set(afname, valueToSet);
                if (isNeedToRefreshGridCell)
                    XPortal.GridInlineEditing.RefreshCell(model, entity, fieldObj, valueToSet);
            } else {
                if (console) console.log("Entity set from: " + entity[afname] + " to: " + action.field.data + ", f:" + afname + ", m:" + action.model);
                entity[afname] = action.field.data;
            }
            if (model && model.model && !action.isDefaultEditor && afname !== "_newrecord") {
                XPortal.Store.SetItemToSave(model, entity, model.model.NodeId, action.updateGrid);
                registerModifedFields(model, afname, afdata, action,state);
            }
        } else {
            if (model.model.IsCreating) {
                var itm = itemsToSave ? itemsToSave.find(i => i.entity.UniqueId === entity.UniqueId) : null;
                if (itm == null) XPortal.Store.SetItemToSave(model, entity, model.model.NodeId, action.updateGrid);
            }
        }
        return Object.assign(state, { editParameters: state.editParameters, pageModels: state.pageModels });
    }
    function dateTimeCutTicks(item) {
        if (!item) return;
        let processVal = item;

        if (typeof processVal.toISOString === 'function') {
            processVal = item.toISOString();
        }
        processVal = processVal.substring(0, processVal.indexOf('.') == -1 ? processVal.length : processVal.indexOf('.'));
        if (processVal.endsWith('Z')) processVal = processVal.slice(0, -1);
        return processVal;
    };
    function compareFieldsVal(fieldObj, checkVal) {
        if (fieldObj.Type == 'DateTime')
            return (dateTimeCutTicks(fieldObj.StringValue || "")) != dateTimeCutTicks(checkVal);

        return (fieldObj.StringValue || "") !== checkVal;
    };
    function stringifyAndNotEquals(obj, compareWith) {
        let ires = obj;
        if ((obj === true || obj === false)) {
            return obj != !(!compareWith);
        }
        if (obj && obj.processed && typeof obj.toISOString === 'function') {
            return dateTimeCutTicks(obj) != dateTimeCutTicks(compareWith);
        }
        if (_.isArray(obj))
            ires = obj.join(self._multipleValueSeparator);
        else if (_.isString(obj))
            ires = obj;
        else if (obj == null) ires = obj;
        else ires = String(obj);

        const res = ires !== compareWith;
        return res;
    }
    function registerModifedFields(model, afname, afdata, action,state) {
        if (!(model && afname)) return;
        afname = afname.toLowerCase();
        const mfs = model.modifiedFields || (model.modifiedFields = []);
        const ix = _.findIndex(mfs, x => x.field == afname);
        const c = { field: afname, tm: new Date().getTime(), v: afdata };
        if (ix) mfs.splice(ix, 1);
        mfs.push(c);
        XPortal.SectionDisplayRules.updateModel(model, action, state);
        XPortal.AutofillFields.updateModel(model, action, state);
        return c;
    };
    function onDisplayFieldEditing(state, action) {
        self.onDebuging(state, action, action.modelName, action.model);
        if (!state.pageModels.hasOwnProperty(action.model))
            return state;
        var model = state.pageModels[action.model];
        var entity = action.entity ? action.entity : model.entity;

        if (entity._events && entity.set) { //grid observable 
            entity.set(action.field.field, action.field.data);
            XPortal.GridInlineEditing.RefreshCell(model, entity, { Name: action.field.field, Type: action.field.ftype }, action.field.data);
        } else
            entity[action.field.field] = action.field.data;
        return Object.assign(state, { editParameters: state.editParameters, pageModels: state.pageModels });
    }
    function onFieldEdited(state, action) {
        self.onDebuging(state, action, action.modelName, action.model, action.options);
        if (state.pageModels.hasOwnProperty(action.options.model)) {
            model = state.pageModels[action.options.model];
            XPortal.Store.SetItemToSave(model, model.entity);
            return Object.assign(state, { pageModels: state.pageModels });
        }
        return state;
    }
    function onFieldDataRefreshed(state, action) {
        return state;
    }
    function onValidateResult(state, action) {
        var currentModel = self.getModel(state, action);
        self.onDebuging(state, action, action.modelName, action.model, action.options, currentModel);
        if (state.editParameters) state.editParameters.WasValidated = true; //for now only have indication if form was validated        
        if (currentModel) currentModel.WasValidated = true; //for now only have indication if form was validated
        XPortal.Store.UpdateStatus(currentModel);
        return Object.assign({}, state);
    }

    function onSaving(state, action) {
        var currentModel = self.getModel(state, action);
        self.onDebuging(state, action, action.modelName, action.model, action.options, currentModel);
        if (currentModel) currentModel.SaveInProgress = true;
        XPortal.Store.UpdateStatus(currentModel);
        return Object.assign({}, state);
    }

    function onNoDataToSave(state, action) {
        return state;
    }

    function onSaved(state, action) {
        var currentModel = self.getModel(state, action);
        self.onDebuging(state, action, action.modelName, action.model, action.options, currentModel);
        if (currentModel) currentModel.SaveInProgress = false;
        XPortal.Store.UpdateStatus(currentModel, action.saved);
        return Object.assign({}, state);
    }

    function onSaveCancel(state, action) {
        var model = self.getModel(state, action);
        self.onDebuging(state, action, action.modelName, action.model, action.options, model.model);
        if (!model.itemsToSave) model.itemsToSave = [];
        while (model.itemsToSave.length)
            model.itemsToSave.pop();
        XPortal.Store.UpdateStatus(model);
        return Object.assign({}, state);
    }

    function onItemSuccessfullySaved(state, action) {
        var modelName = action.modelName;
        state.pageModels = state.pageModels || {};
        var currentModel = state.pageModels[modelName];
        XPortal.AutofillFields.updateModel(null, action, state);
        self.onDebuging(state, action, action.modelName, action.model, action.options, modelName, currentModel);
        if (currentModel && currentModel.itemsToSave) {
            var ind = currentModel.itemsToSave.findIndex(i => i.entity.UniqueId === action.entity.UniqueId);
            if (ind > -1) {
                var modelItem = currentModel.itemsToSave.splice(ind, 1)[0];
                modelItem.entity.IsCreating = false;

                var curEntity = modelItem.entity.UniqueId == action.entity.UniqueId ? modelItem.entity : currentModel.itemsToSave.find(i => i.entity.UniqueId === action.entity.UniqueId);
                if (state.editParameters && state.editParameters.NodeId == modelItem.nodeId)
                    state.editParameters.IsCreating = false;
                var savedResultEntity = XPortal.Grid.MapEntity(action.saveResult);
                modelItem.entity = assignModifiedProperties(curEntity, action.entityBefore, savedResultEntity, currentModel);
                modelItem.entity._newrecord = false;

                if (modelItem.entity.hasOwnProperty("_newInlineRecord"))
                    delete modelItem.entity._newInlineRecord;
                modelItem.entity.EntityAlias = currentModel.model.Alias;
                if (modelItem.entity.set) { //refresh grid checks
                    modelItem.entity.dirty = false;
                    modelItem.entity.set("dirty", false);
                    $("tr[data-uid='" + modelItem.entity.uid + "']").find(".k-dirty").removeClass("k-dirty"); //DIRTY FIX - when user start edit another record it will be not updated
                }
            }
        }
        if (state.editParameters)
            state.editParameters.IsChanged = XPortal.Store.IsEntityToSavePresent(state);
        if (currentModel.itemsToSave.length < 1)
            currentModel.SaveInProgress = false;
        if (action.modelName.startsWith("GM.") && action.updateGrid) {
            var gridSelector = action.modelName.replace("GM.", "");
            $("#" + gridSelector).data("kendoGrid").dataSource.read();
        }
        XPortal.Store.UpdateStatus(currentModel, true);
        return Object.assign({}, state, { LastSave: new Date() });
    }
    function assignModifiedProperties(srcCurrent, srcBefore, dst, currentModel) {
        var mobj = { UniqueId: dst.UniqueId };
        var amount = 0;
        for (var prName in srcBefore) {
            var fieldExists = prName !== prName.toLowerCase() ? false : srcBefore.Fields.find(function (f) { return f.Name.toLowerCase() == prName; });
            if (fieldExists) {
                var bfri = srcBefore[prName] ? String(srcBefore[prName]) : '';
                var dsti = dst[prName] ? String(dst[prName]) : '';
                var crti = srcCurrent[prName] != null ? String(srcCurrent[prName]) : '';
                if (bfri != dsti && bfri == crti) {
                    var lpname = prName.toLowerCase();
                    if (lpname != "updated" && lpname != "_newrecord") {
                        mobj[prName] = dst[prName];
                        amount++;
                    }
                }
            }
        }
        if (amount < 1) return srcCurrent;
        //XPortal.Events.helpers.warn("!!!! reload data with server content:", 0, { to: mobj, from: srcCurrent, before: srcBefore, server: dst });

        currentModel.itemsToRefresh = currentModel.itemsToRefresh || [];
        currentModel.itemsToRefresh.push(mobj);
        return Object.assign(srcCurrent, mobj);
    }
    function onItemFailedSaved(state, action) {
        return state;
    }

    function onDeletingEntity(state, action) {
        var deletedItems = state.deletedItems || [];
        XPortal.AutofillFields.updateModel(null, action, state);
        self.onDebuging(state, action, action.modelName, action.model, action.options, deletedItems);
        if (action.entityList) {
            action.entityList.forEach(function (entity) {
                var ind = deletedItems.findIndex(i => i.UniqueId == entity.UniqueId);
                if (ind > -1) deletedItems[ind] = entity;
                else deletedItems.push(entity);
            });
        }
        return Object.assign({}, state, { deletedItems });
    }

    function onAddMessage(state, action) {
        var currentModel = self.getModel(state, action);
        self.onDebuging(state, action, action.modelName, action.model, currentModel);
        if (currentModel) {
            currentModel.messages = currentModel.messages || {};
            Object.assign(currentModel.messages, action.messages);
        }
        return Object.assign({}, state);
    }
    function onServerMessages(state, action) {
        return state;
    }

    function onUnknownAction(state, action, redType) {
        if (action.type.indexOf("@@") != 0)
            self.onDebuging(state, action, action.modelName, action.model, redType);
        return state;
    }

    function reducerFactory(firstState, handlers, tp) {
        return (state = firstState, action) => {
            if (tp == 'unknown') throw 'reducers type is unknown for state' + Json.stringify(Object.assign(state));
            if (tp == 'dr') return state;
            const concrete = handlers[action.type];
            if (!concrete) return onUnknownAction(state, action, tp);
            var result = concrete(state, action);
            if (result) return result;
            return state;
        };
    }
    /* registrations of all known handlers */
    handlers[self.ACTIONS.VALIDATION_RESULT] = onValidateResult;
    handlers[self.ACTIONS.SAVE_START] = onSaving;
    handlers[self.ACTIONS.SAVE_END] = onSaved;
    handlers[self.ACTIONS.SAVE_CANCEL] = onSaveCancel;
    handlers[self.ACTIONS.ADD_MESSAGES] = onAddMessage;
    handlers[self.ACTIONS.NOTHING_SAVE] = onNoDataToSave;
    handlers[self.ACTIONS.ITEM_SAVE_SUCCESS] = onItemSuccessfullySaved;
    handlers[self.ACTIONS.ITEM_SAVE_FAIL] = onItemFailedSaved;
    handlers[self.ACTIONS.EDIT_FORM_INITIALIZED] = onEditFormInitialized;
    handlers[self.ACTIONS.GRID_INITIALIZE] = onGridInitializing;
    handlers[self.ACTIONS.GRID_INITIALIZED] = onGridInitialized;
    handlers[self.ACTIONS.EDITOR_LOADED] = onEditorLoaded;
    handlers[self.ACTIONS.BIND_ENTITY] = onEntityBinding;
    handlers[self.ACTIONS.LOADED_ENTITY] = onEntityBinded;
    handlers[self.ACTIONS.EDIT_FIELD] = onFieldEditing;
    handlers[self.ACTIONS.EDIT_DISPLAYFIELD] = onDisplayFieldEditing;
    handlers[self.ACTIONS.NOTIFY_EDITED] = onFieldDataRefreshed;
    handlers[self.ACTIONS.END_EDIT] = onFieldEdited;
    handlers[self.ACTIONS.DELETED_ENTITY] = onDeletingEntity;
    handlers[self.ACTIONS.SERVER_MESSAGES] = onServerMessages;
    self.baseReduser = reducerFactory({ stateType: "base", pageModels: {} }, handlers, 'mr');
    self.deleteReduser = reducerFactory({ stateType: "delt", pageModels: {} }, [], 'dr');
    self.lastActionReducer = (state = null, action) => action;

    return self;
}());
